document.addEventListener("DOMContentLoaded", function () {

    // only run above 1400px
    if (window.innerWidth < 1400) return;

    const footerBody = document.querySelector('.wt-footer__body');

    if (!footerBody) return;

    const menuBlocks = footerBody.querySelectorAll('.wt-footer__block.wt-footer__block--menu');

    if (menuBlocks.length) {

        const wrapper = document.createElement('div');
        wrapper.className = 'footer-menu-wrapper';

        // insert wrapper before first menu
        menuBlocks[0].before(wrapper);

        // move all menu blocks into wrapper
        menuBlocks.forEach(block => {
            wrapper.appendChild(block);
        });

    }

});
//progerss bar in single page js

window.addEventListener('load', function() {

    const circles =
        document.querySelectorAll('.progress-circle');

    if(!circles.length) return;

    circles.forEach(function(circle){

        const percent =
            parseInt(circle.getAttribute('data-percent')) || 0;

        const progress =
            circle.querySelector('.progress-fill');

        const number =
            circle.querySelector('.progress-number');

        const radius = 50;

        const circumference =
            2 * Math.PI * radius;

        progress.style.strokeDasharray =
            circumference;

const visualGap = 1.50;

const offset =
    (circumference - (percent / 100) * circumference) * visualGap;

        setTimeout(function(){

            progress.style.strokeDashoffset =
                offset;

        },1500);

        let current = 0;

        const counter = setInterval(function(){

            current++;

            number.innerHTML =
                current + '%';

            if(current >= percent){

                clearInterval(counter);

            }

        },35);

    });

});

